import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, } from 'ionic-angular';
import moment from 'moment';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the ReporteResumenPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-reporte-resumen',
  templateUrl: 'reporte-resumen.html',
})
export class ReporteResumenPage {
  loadModal: any
  vendedor: any
  vendedores: any = []
  selectTitleVendedor: any = {
    title: 'Vendedores',
  }
  selectTitleCliente: any = {
    title: 'Clientes',
  }
  cliente: any
  clientes: any = []
  clientesres: any = []
  facturas: any = [];
  resumen: any = null;
  moneda: any = 'USD'
  super: any = false
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public http : HttpProvider,
    public alertCtrl: AlertController
    ) {
  }

  transform(value) {
    if(value){
      let val = value
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  transform2(item) {
    let value = (parseFloat(item.vencidas) + parseFloat(item.sin_vencer)).toFixed(2)
    if(value){
      let val = parseFloat(value).toFixed(2).split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  async obtenerCli() {
    return await new Promise(async (resolve) =>{
      try {
        const url = this.super ? `cliente/sup?vendedores=${window.localStorage.getItem('vendedores')}` : `cliente/ven/${window.localStorage.getItem('co_ven')}`
        this.http.get(url).subscribe(
          (res: any) => {
            this.clientesres = res
            if (!this.super) this.clientes = res
            resolve("S")
          }, 
          err => {
            console.log(err)
            resolve("N")
          }
        )
      } catch (error) {
        console.log(error)
        resolve("N")
      }
    })
  }

  async obtenerVend() {
    return await new Promise(async (resolve) =>{
      try {
        this.http.get(`vendedor/allReportResu?vendedores=${window.localStorage.getItem('vendedores')}`).subscribe(
          (res: any) => {
            this.vendedores = res
            resolve("S")
          }, 
          err => {
            console.log(err)
            resolve("N")
          }
        )
      } catch (error) {
        console.log(error)
        resolve("N")
      }
    })
  }

  async obtenerFact() {
    return await new Promise(async (resolve) =>{
      try {
        this.http.get(`factura/resumen?cli=${this.cliente.co_cli.trim()}`).subscribe(
          (res:any=[])=>{
            console.log(res)
            this.resumen = res
            resolve("S")
          }, err=>{
            console.log(err)
            resolve("N")
        })
      } catch (error) {
        console.log(error)
        resolve("N")
      }
    })
  }

  asignarCliente() {
    this.clientes = [];
    for (let i = 0; i < this.clientesres.length; i++) {
      const el = this.clientesres[i];
      if (el.co_ven.trim() == this.vendedor.trim()) this.clientes.push(el)
    }
  }

  async buscar() {

  }

  async ionViewDidEnter() {
    if(window.localStorage.getItem('super')){
      this.super = true
    } else this.super = false
    this.updateMoneda()
    if(window.localStorage.getItem('network') === '1') {
      this.ActivarLoading()
      if (this.super) await this.obtenerVend()
      await this.obtenerCli()
      this.DesactivarLoading()
    } else {
      this.alertCtrl.create({
        title: 'Atención',
        subTitle:'No se encuentra conexión con ninguna red.',
        buttons:[
          {
            text:'Aceptar',
            cssClass:'btnAceptar',
            handler:()=>{
            }
          }
        ]
      }).present()
    }
  }

  ActivarLoading() {
    this.loadModal = this.loadingCtrl.create({
      content: 'Por favor espere...'
    });
    this.loadModal.present();
  }
  DesactivarLoading() {
    this.loadModal.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/reporte-resumen/reporte-resumen.ts